module.exports = __webpack_public_path__ + "img/building.bd760d2a.png";